import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { useSelector } from "react-redux";

import useTheme from "hooks/useTheme";
import CloseIcon from "theme/icons/Close";

const SendSwapTransactionModal = ({
	isOpen,
	setIsOpen,
	// swapQuoteRoutes,
	// swapQuoteProfit,
	payingAsset,
	payingAmount,
	buyingAsset,
	minimumReceived,
	sendPayment,
}) => {
	const { appLanguage, themeColor } = useTheme();

	const sendingTransaction = useSelector((state) => state.SendingTransaction);

	return (
		<Transition appear show={isOpen} as={Fragment}>
			<Dialog as="div" className="relative z-10" onClose={() => {}}>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div className={`fixed inset-0 ${themeColor?.bg} bg-opacity-30`} />
				</Transition.Child>

				<div className="fixed inset-0 overflow-y-auto">
					<div className="flex min-h-full items-center justify-center p-4 text-center">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 scale-95"
							enterTo="opacity-100 scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 scale-100"
							leaveTo="opacity-0 scale-95"
						>
							<Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
								<div className="flex w-full space-x-4 items-center">
									<div className="flex-col w-full space-y-4">
										{!sendingTransaction && (
											<div className="flex w-full items-center justify-between">
												<p className={`text-md ${themeColor?.text}`}></p>
												<CloseIcon
													className="w-4 cursor-pointer"
													fill={themeColor?.hex}
													onClick={() => setIsOpen(false)}
												/>
											</div>
										)}

										<Dialog.Title
											as="h3"
											className={`flex flex-col items-center justify-center font-medium leading-6 ${themeColor?.text} space-y-1`}
										>
											<div className="flex space-x-1">
												<p className={`text-lg ${themeColor?.text}`}>{appLanguage?.swap}</p>
												<p className={`text-lg ${themeColor?.text}`}>{payingAmount && payingAmount}</p>
												<p className={`text-lg ${themeColor?.text}`}>{payingAsset?.["unit-name"]}</p>
												<p className={`text-lg ${themeColor?.text}`}>{appLanguage?.forAtLeast}</p>
												<p className={`text-lg ${themeColor?.text}`}>{minimumReceived}</p>
												<p className={`text-lg ${themeColor?.text}`}>{buyingAsset?.["unit-name"]}</p>
											</div>
										</Dialog.Title>
										{/* <Dialog.Description
											as="h3"
											className={`flex flex-col items-center justify-center font-medium leading-6 ${themeColor?.text} space-y-1`}
										>
											<p className={`text-sm ${themeColor?.text}`}>Transaction Groups to sign</p>
											{swapQuoteRoutes &&
												swapQuoteRoutes.map((swapQuoteRoute, index) => (
													<div className="flex flex-col w-full items-center justify-center" key={index}>
														{swapQuoteRoute["path"] && swapQuoteRoute["path"].length === 1
															? swapQuoteRoute["path"].map((path, index) => (
																	<div
																		className="flex flex-col items-center justify-center"
																		key={index}
																	>
																		<p
																			className={`text-sm font-bold ${themeColor?.text}`}
																		>
																			{`Swap ${payingAmount} ${
																				path["in"]["unit_name"]
																			} for at least ${(
																				(minimumReceived} ${path["out"]["unit_name"]}`}
																		</p>
																		<p
																			className={`text-sm font-bold ${themeColor?.text}`}
																		>
																			{path["name"]}
																		</p>
																	</div>
															  ))
															: swapQuoteRoute["path"].map((path, index) =>
																	index === 0 ? (
																		<div
																			className="flex flex-col items-center justify-center"
																			key={index}
																		>
																			<p className={`text-sm ${themeColor?.text}`}>
																				{`Swap ${swapQuoteRoute["percentage"] / 100} ${
																					path["in"]["unit_name"]
																				} for at least X ${path["out"]["unit_name"]}`}
																			</p>
																			<p className={`text-sm ${themeColor?.text}`}>
																				{path["name"]}
																			</p>
																		</div>
																	) : swapQuoteProfit["asa"]["unit_name"] ===
																	  path["out"]["unit_name"] ? (
																		<div
																			className="flex flex-col items-center justify-center"
																			key={index}
																		>
																			<p className={`text-sm ${themeColor?.text}`}>
																				{`Swap X ${
																					path["in"]["unit_name"]
																				} for at least ${(
																					(minimumReceived} ${path["out"]["unit_name"]}`}
																			</p>
																			<p className={`text-sm ${themeColor?.text}`}>
																				{path["name"]}
																			</p>
																		</div>
																	) : (
																		<div
																			className="flex flex-col items-center justify-center"
																			key={index}
																		>
																			<p className={`text-sm ${themeColor?.text}`}>
																				{`Swap X ${path["in"]["unit_name"]} for at least X ${path["out"]["unit_name"]}`}
																			</p>
																			<p className={`text-sm ${themeColor?.text}`}>
																				{path["name"]}
																			</p>
																		</div>
																	)
															  )}
													</div>
												))}
										</Dialog.Description> */}
									</div>
								</div>

								<div className="w-full flex mt-4 space-x-3 items-center justify-center">
									{sendingTransaction ? (
										<img className="animate-spin mx-auto h-5 w-auto" src="/media/logo.png" alt="img" />
									) : (
										<button
											type="button"
											className={`inline-flex justify-center rounded-md border px-4 py-2 text-sm font-medium text-white ${themeColor?.bg}`}
											onClick={() => sendPayment()}
										>
											{appLanguage?.confirm}
										</button>
									)}
									{/* <button
										type="button"
										className={`inline-flex justify-center text-sm font-medium ${themeColor['text-color']}`}
										onClick={() => setIsOpen(false)}
									>
										Cancel
									</button> */}
								</div>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition>
	);
};

export default SendSwapTransactionModal;
